import { Component, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router }  from '@angular/router';

import { RestaurantProvider } from '../../providers/restaurant';

declare var google;

@Component({
    selector: 'page-home',
    templateUrl: './home.html',
    styleUrls: ['./home.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomePage {

	@ViewChild("address")
  address: ElementRef;

	private combSubject: Subject<any>;
	private restSub: Subscription;

	isSearch: boolean = false;
	public geo: any;
	public rests: Array<any> = [];

	form: FormGroup;

	private radius: any = 2;
	
	constructor (
		protected restProv: RestaurantProvider,
		private _fb: FormBuilder,
		private router: Router
	) {
		this.form = this._fb.group({
			address: [''],
		});
	}

	ngOnInit() {
		this.combSubject = new Subject;
		this.restSub = this.combSubject.combineLatest(this.restProv.list(), (val1, val2) => {
			if (val1 == null) {
				return val2.sort( () => { return 0.5 - Math.random(); } ).slice(0, 6);
			} else {
				return val2.filter(item => this.getDistanceFromLatLonInKm(val1.latitude, val1.longitude, item.geo.latitude, item.geo.longitude) <= this.radius);
			}
		}).subscribe(val => {
			this.rests = val;
			if (this.rests.length == 0 && this.radius <= 512) {
				this.radius = this.radius * 2;
				this.combSubject.next(this.geo);
			}
		});
		this.combSubject.next(this.geo);
	}

	ngAfterViewInit() {
		let autocomplete = new google.maps.places.Autocomplete(this.address.nativeElement);
		google.maps.event.addListener(autocomplete, 'place_changed', () => {
    	let place = autocomplete.getPlace();
    	this.form.controls['address'].setValue(place.formatted_address);
    	this.geo = {
    		latitude: place.geometry.location.lat(),
    		longitude: place.geometry.location.lng()
    	};
    });
	}

	ngOnDestroy() {
		this.restSub.unsubscribe();
	}

	onSelect(rest: any) {
		this.router.navigate(['/restaurant', rest.uid, rest.key]);
	}

	searchForm() {
		if (this.form.value.address != '') {
			this.isSearch = true;
		} else {
			this.isSearch = false;
			this.geo = null;
		}
		this.radius = 2;
		this.combSubject.next(this.geo);
	}

	private getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2): any {
	  let R = 6371; // Radius of the earth in km
  	let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
  	let dLon = this.deg2rad(lon2-lon1); 
  	let a = 
	    Math.sin(dLat/2) * Math.sin(dLat/2) +
	    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
	    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
	  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		let d = R * c; // Distance in km
	  return d;
	}

	private deg2rad(deg):any {
	  return deg * (Math.PI/180)
	}
}



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/home/home.ts